import { Injectable } from "@angular/core";
import format from "date-fns/format";

@Injectable({
  providedIn: "root"
})
export class LoggingService{
  log(...args){
    let text = "";

    try{
      let message = "";
      let clsName = "";
      let methodName = "";
      let msgCount = args.length;

      if (args.length >= 3){
        clsName = args[args.length - 2];
        methodName = args[args.length - 1];
        msgCount = args.length - 2;
      }

      text = `${format(new Date(), "MM/dd/yyyy HH:mm:ss")} ${clsName}.${methodName}()`;

      for (var i = 0; i < msgCount; i ++){
        if (args[i] instanceof String){
          message += args[i] + " ";
        }
        else{
          message += JSON.stringify(args[i]) + " ";
        }
      }

      if (message.length > 100){
        message = message.substr(0, 100);
      }
      
      text = `${text} ${message}`;
    }
    catch(e){}

    return text;
  }

}